import { FormControl, ValidationErrors } from '@angular/forms';

/**
 * validateINSZ
 *
 * The following code is copied from the validate-insz npm package:
 * https://github.com/SimonJang/validate-insz
 *
 * The code is copied because the package is no longer maintained.
 */
const calculate = (modulo, checksum) => {
	const rest = parseInt(modulo, 10) % 97;

	return 97 - rest === checksum;
};

const validateINSZ = (insz) => {
	const regex = /^\d{2}.\d{2}.\d{2}-\d{3}.\d{2}$/;
	const altRegex = /^\d{11}$/;

	if (typeof insz !== 'string') {
		throw new TypeError('Expected INSZ number to be a `string`, got `' + typeof insz + '`');
	}

	if (!regex.test(insz) && !altRegex.test(insz)) {
		return false;
	}

	const cleanedSSN = insz.replace(/[.-]/g, '');

	const moduloCheckString = cleanedSSN.slice(0, cleanedSSN.length - 2);
	const checksum = parseInt(cleanedSSN.slice(cleanedSSN.length - 2), 10);

	return calculate(moduloCheckString, checksum) || calculate('2' + moduloCheckString, checksum);
};

/**
 * INSZValidator
 *
 * The INSZValidator will use the validate-insz npm package
 * to validate the giving input and check if it is a valid INSZ number.
 *
 * @param { FormControl } control
 * @returns ValidationErrors
 * @returns null
 */
export function INSZValidator(control: FormControl): ValidationErrors | null {
	if (!control.value) {
		return null;
	}

	const insz = control.value.replace(/[.\-]/g, '');

	return validateINSZ(insz) ? null : { invalidINSZ: true };
}
